import alt from 'components/Dispatcher';

class StagingArchivingProfileActions {
  constructor() {
    this.generateActions('updateArchivingProfile');
  }
}

export default alt.createActions(StagingArchivingProfileActions);
